import React from 'react';
import { Login as LoginComponent } from '../components/auth/Login';

export const LoginPage: React.FC = () => {
  return <LoginComponent />;
};